import usersApi from "../../services/api/UsersApi";

const actions = {
  async getAllUsers({ commit }) {
    let err, response;
    try {
      [err, response] = await usersApi.getAllUsers();

      if (!err) {
        commit("SET_USERS", response.data);
        return response;
      }
    } catch (e) {
      console.log(e);
    }
  },
  async getUserById({ commit }, id) {
    let err, response;
    try {
      [err, response] = await usersApi.getUserById(id);
      if (!err) {
        commit("SET_USER", response.data);
        return response;
      }
    } catch (e) {
      console.log(e);
    }
  },
  async updateUserById({ commit }, id) {
    let err, response;
    try {
      [err, response] = await usersApi.updateUserById(id);
      if (!err) {
        commit("UPDATE_USER", response.data);
        return response;
      }
    } catch (e) {
      console.log(e);
    }
  },
  async deleteUserById({ commit }, id) {
    let err, response;
    try {
      [err, response] = await usersApi.deleteUserById(id);
      if (!err) {
        commit("DELETE_USER", response.data);
        return response;
      }
    } catch (e) {
      console.log(e);
    }
  },

  async registerUser({ commit }, user) {
    let err, response;
    try {
      [err, response] = await usersApi.registerUser(user);
      if (!err) {
        commit("REGISTER_USER", response.data);
        return response;
      }
    } catch (e) {
      console.log(e);
    }
  },

  async resetPassword({ commit }, pass) {
    let err, response;
    try {
      [err, response] = await usersApi.resetPassword(pass);
      if (!err) {
        commit("RESET_PASSWORD", response.data);
        return response;
      }
    } catch (e) {
      console.log(e);
    }
  }
};

export default actions;
